import $ from 'jquery';
import StateManager from '../scuba/StateManager';

require('readmore-js');

$(window).on(StateManager.CONTENT_READY, function(event, node) {
    $(node).find('.js-ellipsis').each(function(i, el) {
        $(el).readmore({
          speed: 75,
          collapsedHeight: 110, // 6*22
          heightMargin: 24,
          lessLink: '<a href="#">Lire moins</a>',
          moreLink: '<a href="#">Lire plus</a>',
        });
    });
});


// WEBPACK FOOTER //
// ./scripts/components/Ellipsis.js